<div class="container py-5 text-center">
  <h1 class="display-5">Access denied</h1>
  <p class="text-muted">Your account does not have permission to open this module.</p>
  <a class="btn btn-primary" routerLink="/store/phase1">Return to Store Setup</a>
</div>
